export default __webpack_public_path__ + "static/media/bannerMobile.70257ef4.png";